import { createContext, useContext, useEffect, useMemo } from "react";
import { navigateToRoute } from "./navigateToRoute";

const TemaRouteContext = createContext(null);

export function TemaRouteProvider({ route, hash, children }) {
  useEffect(() => {
    if (route?.documentTitle) {
      document.title = route.documentTitle;
    }
  }, [route?.documentTitle]);

  const value = useMemo(
    () => ({
      route,
      hash,
      breadcrumbs: route?.breadcrumbs ?? [],
      navigateToRoute,
      isWorkspaceRoute: Boolean(route?.workspace),
      isNotFound: route?.id === "not-found",
    }),
    [hash, route],
  );

  return (
    <TemaRouteContext.Provider value={value}>{children}</TemaRouteContext.Provider>
  );
}

export function useTemaRoute() {
  const context = useContext(TemaRouteContext);
  if (!context) {
    throw new Error("useTemaRoute must be used within TemaRouteProvider");
  }
  return context;
}

export function useOptionalTemaRoute() {
  return useContext(TemaRouteContext);
}
